/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Generate_Expiryinvalid3Inputs */

const en_settings_reportingapikeys_generate_expiryinvalid3 = /** @type {(inputs: Settings_Reportingapikeys_Generate_Expiryinvalid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expiry must be between 1 and 365 days.`)
};

/**
* | output |
* | --- |
* | "Expiry must be between 1 and 365 days." |
*
* @param {Settings_Reportingapikeys_Generate_Expiryinvalid3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generate_expiryinvalid3 = /** @type {((inputs?: Settings_Reportingapikeys_Generate_Expiryinvalid3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generate_Expiryinvalid3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generate_expiryinvalid3(inputs)
});
export { settings_reportingapikeys_generate_expiryinvalid3 as "settings_reportingApiKeys_generate_expiryInvalid" }